module.exports = __webpack_public_path__ + "img/9788960177116.77a4e4cf.jpg";